import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const translations = {
  en: {
    title:
      "Life in the UK test preparation made simple for Bangla-speaking learners.",
    subtitle:
      "Prepare confidently with practice questions, study materials, and mock tests. Start learning now.",
    startButton: "Start practice",
    slides: [
      {
        title: "Practice Questions",
        description: "Study hundreds of Life in the UK questions with answers",
      },
      {
        title: "Welcome to LUKT Bangla",
        description:
          "Your complete companion for Life in the UK citizenship test preparation",
      },
      {
        title: "Track Progress",
        description:
          "Monitor your improvement and learn which chapters need more practice",
      },
    ],
  },
  bn: {
    title:
      "বাংলা ভাষাভাষী শিক্ষার্থীদের জন্য লাইফ ইন দ্য ইউকে টেস্ট প্রস্তুতি এখন আরও সহজ।",
    subtitle:
      "শত শত প্রশ্ন, অধ্যায়ভিত্তিক পড়াশোনা এবং মক টেস্ট—সব কিছু এক জায়গায়। এখনই প্রস্তুতি শুরু করুন।",
    startButton: "প্রস্তুতি শুরু করুন",
    slides: [
      {
        title: "অনুশীলন প্রশ্ন",
        description:
          "লাইফ ইন দ্য ইউকে টেস্টের শত শত প্রশ্ন ও ব্যাখ্যা সহ অনুশীলন করুন",
      },
      {
        title: "LUKT Bangla এ স্বাগতম",
        description:
          "ইউকে সিটিজেনশিপ টেস্ট প্রস্তুতির জন্য আপনার সম্পূর্ণ বাংলা সহায়ক অ্যাপ",
      },
      {
        title: "অগ্রগতি ট্র্যাক করুন",
        description:
          "আপনার উন্নতি পর্যবেক্ষণ করুন এবং কোথায় আরও পড়াশোনা প্রয়োজন তা নির্ধারণ করুন",
      },
    ],
  },
};

function Home() {
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";
  const t = translations[lang];

  return (
    <div className={`home ${lang === "bn" ? "bn-font" : ""}`}>
      <p className="home-title">{t.title}</p>
      <p className="home-title-small">{t.subtitle}</p>
      <button onClick={() => navigate("/login")} className="home-start-button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-list-todo w-5 h-5 mr-2"
        >
          <rect x="3" y="5" width="6" height="6" rx="1"></rect>
          <path d="m3 17 2 2 4-4"></path>
          <path d="M13 6h8"></path>
          <path d="M13 12h8"></path>
          <path d="M13 18h8"></path>
        </svg>
        <span>{t.startButton}</span>
      </button>
      <div className="pricing-comparison">
        <div className="comparison-title">Upgrade to Premium and Enjoy:</div>
        <table className="comparison-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Free</th>
              <th>Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Full access to all chapters of study materials</td>
              <td>2 Chapters</td>
              <td>All</td>
            </tr>
            <tr>
              <td>Unlimited mock tests</td>
              <td>❌</td>
              <td>✅</td>
            </tr>

            <tr>
              <td>All practice questions unlocked</td>
              <td>❌</td>
              <td>✅</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="home-slide-container">
        {t.slides.map((slide, index) => (
          <div key={index} className="home-slide">
            <img
              className="home-slide-img"
              src={`/Assets/Logos/intro${index + 1}.png`}
              alt={slide.title}
            />
            <p className="home-slide-title-1">{slide.title}</p>
            <p className="home-slide-title-2">{slide.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;
